'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OmniSearchController = function () {
  function OmniSearchController($scope, $ngConfirm, authService, enums, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, OmniSearchController);
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.enums = enums;
    this.$state = $state;
    this.authService = authService;

    this.searchTerm;

    this.panels = [];
    this.panels['enquiries'] = { loading: false, results: null };
    this.panels['contacts'] = { loading: false, results: null };

    this.currentEntityId = authService.authData.currentLocation.key;

    this.searching = false;
  }

  (0, _createClass3.default)(OmniSearchController, [{
    key: 'search',
    value: function search() {
      if (!this.searchTerm || this.searchTerm.length < 3) {
        this.$ngConfirm({
          title: "Error",
          content: 'Please search with a minimum of 3 characters',
          type: 'red',
          buttons: {
            ok: function ok() {}
          }
        });

        return;
      }

      this.panels.enquiries.loading = true;
      this.panels.contacts.loading = true;
      this.searching = true;

      this.$scope.$broadcast('omniSearch:search', this.searchTerm);
    }
  }, {
    key: 'panelLoaded',
    value: function panelLoaded(panelName, numResults) {
      this.panels[panelName].loading = false;
      this.panels[panelName].results = numResults;

      this.allPanelsLoaded();
    }
  }, {
    key: 'allPanelsLoaded',
    value: function allPanelsLoaded() {
      this.searching = (0, _lodash.find)(this.panels, function (o) {
        return o.loading;
      }) != null;
    }
  }, {
    key: 'linkSelected',
    value: function linkSelected(selectedObj) {
      var _this = this;

      if (selectedObj.entityId === this.currentEntityId) {
        this.gotoLink(selectedObj);
        return;
      }

      this.$ngConfirm({
        title: "Warning",
        content: 'The object you\'re trying to navigate is not in your currently selected location.<br><br>If you wish to proceed, your selected location will be updated',
        type: 'orange',
        columnClass: 'l',
        buttons: {
          ok: {
            text: 'Proceed',
            btnClass: 'btn-primary',
            action: function action() {
              _this.authService.updateLocationById(selectedObj.entityId);
              _this.gotoLink(selectedObj);
            }
          },
          cancel: {
            text: 'Not sure',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'gotoLink',
    value: function gotoLink(selectedObj) {
      switch (selectedObj.objectType) {
        case this.enums.OMNISEARCH_OBJECT_TYPE.Enquiry:
          this.$state.go('enquiryEdit', { enquiryId: selectedObj.objectId });
          break;

        case this.enums.OMNISEARCH_OBJECT_TYPE.Contact:
          this.$state.go('contactView', { contactId: selectedObj.objectId });
          break;
      }
    }
  }]);
  return OmniSearchController;
}();

exports.default = OmniSearchController;


// WEBPACK FOOTER //
// ./client/app/components/omniSearch/omniSearch.controller.js